import { Abi } from 'viem';
import { StakingContract } from 'utils/constants/abi/StakingContract';
import rewardsContractAbi from 'utils/constants/abi/Rewards.json';
import { ERC20ABI } from 'structure/pv2/vault/components/abi/ERC20ABI';
import { StakingPool } from 'api/StakingAPI';

/**
 * Creates contract call configurations for fetching staking pool data
 */
export const createPoolDataContractCalls = (
  pool: StakingPool,
  chainId: number
) => {
  if (!pool.stakingContractAddress || !pool.rewardsContractAddress) {
    return [];
  }

  const depositTokenAddress = pool.depositTokenAddress;

  const contractCalls = [
    // Staking Contract calls (12 calls)
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'MAX_EARLY_UNLOCK_FEE',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'MAX_EARLY_UNLOCK_FEE_PER_DAY',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'MAX_LOCKING_PERIOD',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'MAX_PERCENTAGE',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'claim',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'depositToken',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'earlyUnlockFeePerDay',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'earlyUnlockFees',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'owner',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'rewardToken',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'rewardsAPI',
      chainId,
    },
    {
      address: pool.stakingContractAddress,
      abi: StakingContract as Abi,
      functionName: 'totalScore',
      chainId,
    },
    // ERC20 balanceOf call (to get total volume locked)
    ...(depositTokenAddress
      ? [
          {
            address: depositTokenAddress as `0x${string}`,
            abi: ERC20ABI as Abi,
            functionName: 'balanceOf',
            args: [pool.stakingContractAddress],
            chainId,
          },
        ]
      : []),
    // Rewards Contract calls (3 calls)
    {
      address: pool.rewardsContractAddress,
      abi: rewardsContractAbi as Abi,
      functionName: 'reward',
      chainId,
    },
    {
      address: pool.rewardsContractAddress,
      abi: rewardsContractAbi as Abi,
      functionName: 'getRewardInfo',
      chainId,
    },
    {
      address: pool.rewardsContractAddress,
      abi: rewardsContractAbi as Abi,
      functionName: 'rewardsCommissionPercentage',
      chainId,
    },
  ];

  return contractCalls;
};

/**
 * Creates contract call configurations for fetching user pool info
 */
export const createUserPoolInfoContractCalls = (
  poolContractAddress: `0x${string}`,
  walletAddress: `0x${string}`,
  chainId: number
) => {
  return [
    {
      address: poolContractAddress,
      abi: StakingContract as Abi,
      functionName: 'userInfo',
      args: [walletAddress],
      chainId,
    },
    {
      address: poolContractAddress,
      abi: StakingContract as Abi,
      functionName: 'pendingFor',
      args: [walletAddress],
      chainId,
    },
  ];
};
